module.exports = __webpack_public_path__ + "img/customerService.ea762ed2.svg";